import { z } from 'zod';
import { SanityAssetSourceSchema, SanityDocumentSchema } from '../sanity';
import { ImageObjectSchema } from './Image';
import { ComponentType } from '$lib/sanity/types';

export const MuxVideoSchema = z.object({
  _id: z.string(),
  playbackId: z.string(),
  data: z.object({
    aspect_ratio: z.string()
  }),
  thumbTime: z.number().optional()
});

export const VideoObjectSchema = z.object({
  asset: SanityAssetSourceSchema
});

export const CaptionsObjectSchema = z.object({
  asset: SanityAssetSourceSchema
});

export const VideoSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Video),
  name: z.string(),
  variant: z.string(),
  title: z
    .string()
    .nullish()
    .transform((x) => x ?? 'Video'),
  description: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  muxVideo: MuxVideoSchema.nullish(),
  youtubeID: z.string().nullish(),
  poster: ImageObjectSchema.nullish(),
  captions: CaptionsObjectSchema.nullish(),
  youtubeOptions: z
    .object({
      showControls: z
        .boolean()
        .nullish()
        .transform((x) => x ?? true)
    })
    .nullish()
    .transform((x) => x ?? { showControls: true }),
  muxOptions: z
    .object({
      autoplay: z
        .boolean()
        .nullish()
        .transform((x) => x ?? false),
      loop: z
        .boolean()
        .nullish()
        .transform((x) => x ?? false),
      muted: z
        .boolean()
        .nullish()
        .transform((x) => x ?? false),
      showControls: z
        .boolean()
        .nullish()
        .transform((x) => x ?? false)
    })
    .nullish()
    .transform((x) => x ?? { autoplay: false, loop: false, muted: false, showControls: true })
});

export type Video = z.infer<typeof VideoSchema>;
export type MuxVideo = z.infer<typeof MuxVideoSchema>;
